/**
 * Config del Panel del Promotor Digital.
 *
 * URLs absolutas del .env de la brand (SSOT: infra → generate-env genPromoter).
 * En dev API_URL queda vacío → proxy de Vite. En prod, fail-fast si falta.
 */

const VITE_API_URL = import.meta.env.VITE_API_URL;
const VITE_CUSTOMER_URL = import.meta.env.VITE_CUSTOMER_URL;

if (!import.meta.env.DEV && !VITE_API_URL) {
    throw new Error('[PromoterConfig] VITE_API_URL obligatorio en build prod. Verificar .env.');
}

const API_URL = import.meta.env.DEV ? '' : VITE_API_URL;

// Fallback del link de afiliación: el real viene de GET /api/cashier/config
// (urlJuego, con herencia fractal del nodo). Este es solo el respaldo si la
// config no trajera urlJuego por algún motivo.
const CUSTOMER_URL_FALLBACK = VITE_CUSTOMER_URL || '';

const STORAGE_KEYS = {
    TOKEN: 'promoter_token',
    USER: 'promoter_user',
    DISPOSITIVO_TOKEN: 'promoter_dispositivo_token',
    SERIAL: 'promoter_serial',
    WEB_FINGERPRINT: 'promoter_web_fingerprint',
    ONBOARDING_VISTO: 'promoter_onboarding_visto',
    MENSAJE_COMPARTIR: 'promoter_mensaje_compartir',
    // Email del último login exitoso, para pre-rellenar el campo al reentrar
    // (el promotor solo teclea la seña; no reescribe su correo cada vez).
    ULTIMO_EMAIL: 'promoter_ultimo_email',
};

export const PromoterConfig = {
    API_URL,
    CUSTOMER_URL_FALLBACK,
    STORAGE_KEYS,
};

export default PromoterConfig;
